import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  FormControl,
} from '@mui/material';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';

import { useRecoilState, useRecoilValue } from 'recoil';
import { dialogState, formTemplateState, layoutSelector } from 'state';
import { set } from 'object-path';
import { produce } from 'immer';
import Editor from 'react-simple-wysiwyg';
import { FormTemplateStatus } from 'api/models/FormTemplate';

export function EditHeaderDialog() {
  const [{ data }, closeDialog] = useRecoilState(dialogState);
  const { layoutItem, path } = data;
  const { t } = useTranslation();
  const [layout, setLayout] = useRecoilState(layoutSelector);
  const formTemplate = useRecoilValue(formTemplateState);
  const disabled = formTemplate?.status === FormTemplateStatus.Published;

  const formik = useFormik({
    initialValues: {
      name: layoutItem.label ?? '',
    },
    onSubmit(values, { resetForm }) {
      const items = produce(layout, draft => {
        set(draft, `${path}.label`, values.name);
      });
      setLayout(items);

      resetForm();

      closeDialog({
        isOpen: false,
      });
    },
  });

  return (
    <Box>
      <DialogTitle>{t('dialogs.editDividerField.title')}</DialogTitle>
      <DialogContent>
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth sx={{ mt: 1, mb: 2 }}>
                <Editor
                  disabled={disabled}
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  name="name"
                />
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            closeDialog({
              isOpen: false,
            });
          }}
          color="secondary"
          variant="contained"
          sx={{ mb: 1 }}
        >
          {t('general.cancel')}
        </Button>
        <Button
          disabled={!formik.isValid || disabled}
          type="submit"
          color="primary"
          variant="contained"
          onClick={formik.submitForm}
          sx={{ mr: 2, mb: 1 }}
        >
          {t('general.save')}
        </Button>
      </DialogActions>
    </Box>
  );
}
